import { render } from "./SidebarUserLogout.vue?vue&type=template&id=423c4b3c&scoped=true"
import script from "./SidebarUserLogout.vue?vue&type=script&lang=js"
export * from "./SidebarUserLogout.vue?vue&type=script&lang=js"

import "./SidebarUserLogout.vue?vue&type=style&index=0&id=423c4b3c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423c4b3c"]])

export default __exports__